//login user
export const loginUser = (user) => {
  return {
    url: "/user/login",
    method: "POST",
    body: {
      email: user.email,
      password: user.password,
    },
  };
};

//get admin summary
export const getSummary = () => {
  return {
    url: "/admin/dashboard",
    mehtod: "GET",
  };
};

//get admin profile
export const getProfile = () => {
  return {
    url: "/user/profile",
    mehtod: "GET",
  };
};

//update admin profile
export const updateProfile = (data) => {
  return {
    url: "/user/profile",
    method: "PATCH",
    body: { ...data },
  };
};
